import { Box, Grid, Pagination } from "@mui/material";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    DialogContainer,
    EmptyListMessage,
    EndOfInfiniteListMessage,
    PageWithFilter,
    Spinner,
} from "../../../components/exports";
import FilteredPage from "../../../components/shared/FilteredPage";
import { DialogContext } from "../../../contexts/DialogContext";
import { fetchSales, resetAndFetchSales } from "../../../slices/SalesSlice";
import { RootState } from "../../../slices/Store";
import ProjectItem from "../../projects/components/ProjectItem";
import SalesFilter from "../components/SalesFilter";
import TodayHeader from "../components/TodayHeader";
import { TodayType } from "./Today";

export default function TodaySales(props: {
    type: TodayType;
    onChange: (type: TodayType) => void;
}) {
    const dispatch = useDispatch();
    const { openDialog } = useContext(DialogContext);
    const saleState = useSelector((state: RootState) => state.salesState);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        resetAndFetchSales(saleState, dispatch);
    }, []);

    useEffect(() => {
        if (!saleState.isFetching && isLoading) {
            setIsLoading(false);
        }
    }, [saleState.isFetching]);

    const handlePageChange = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        fetchSales(saleState, dispatch, page - 1);
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const openFilter = () => {
        openDialog(
            <DialogContainer>
                <SalesFilter />
            </DialogContainer>
        );
    };

    return (
        <Box sx={{ overflow: "auto", height: "100%" }}>
            <PageWithFilter filter={<SalesFilter />}>
                <FilteredPage>
                    <TodayHeader
                        type={props.type}
                        onChange={props.onChange}
                        openFilter={openFilter}
                        totalCount={saleState.totalCount}
                    />

                    {(isLoading || saleState.isFetching) && <Spinner />}

                    {!isLoading && (
                        <>
                            {!saleState.isFetching &&
                                saleState.sales.length === 0 && (
                                    <EmptyListMessage message="فرایند فروشی یافت نشد" />
                                )}

                            {!saleState.isFetching &&
                                saleState.sales.length > 0 && (
                                    <>
                                        <Grid container spacing={2}>
                                            {saleState.sales.map((p) => {
                                                return (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        md={6}
                                                        lg={4}
                                                        xl={4}
                                                        key={p.sale.id}
                                                    >
                                                        <ProjectItem
                                                            project={p.project}
                                                            sale={p}
                                                            isLoading={
                                                                saleState.isFetching
                                                            }
                                                        />
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>

                                        {saleState.totalCount >
                                        saleState.limit ? (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    mt: 2,
                                                }}
                                            >
                                                <Pagination
                                                    count={Math.ceil(
                                                        saleState.totalCount /
                                                            saleState.limit
                                                    )}
                                                    color="primary"
                                                    page={saleState.page + 1}
                                                    onChange={handlePageChange}
                                                />
                                            </Box>
                                        ) : (
                                            <EndOfInfiniteListMessage />
                                        )}
                                    </>
                                )}
                        </>
                    )}
                </FilteredPage>
            </PageWithFilter>
        </Box>
    );
}
